<template>
  <div v-if="stages">
    <template v-for="(stage, i) in stages">
      <div
        :key="'stage_' + i"
        class="distance_label distance_label__border"
      >
        Этап {{ i + 1 }}
        <div
          :id="`delete-stage-tooltip-${i + 1}`"
          class="d-inline-block"
          tabindex="0"
        >
          <b-button
            title="Удалить"
            variant="flat-danger"
            class="btn-icon inline-block"
            size="sm"
            :disabled="isRestricted"
            @click="deleteStage(stage)"
          >
            <feather-icon icon="MinusIcon" />
          </b-button>
        </div>
        <b-tooltip
          v-if="isRestricted"
          :target="`delete-stage-tooltip-${i + 1}`"
          triggers="hover"
        >
          В данной дистанции есть регистрации
        </b-tooltip>
      </div>
      <label
        for="stageName"
        class="distance_label"
      >Название этапа</label>
      <b-form-input
        id="stageName"
        :key="'stage.name_' + i"
        v-model="stage.name"
        placeholder="Название этапа"
        vs-placeholder="Название этапа"
        class="distance-stage--input"
      />
      <label class="distance_label">Вид спорта</label>
      <v-select
        :key="'stage.kind_of_sport_id_' + i"
        v-model="stage.kind_of_sport_id"
        :options="kindOfSports"
        label="name"
        class="distance-stage--input"
        :reduce="option => option.id"
        placeholder="Вид спорта"
      />
      <label
        for="stageSex"
        class="distance_label"
      >Пол</label>
      <b-form-input
        id="stageSex"
        :key="'stage.sex_' + i"
        v-model="stage.sex"
        placeholder="Пол"
        vs-placeholder="Пол"
        class="distance-stage--input"
      />
      <label
        for="stageLength"
        class="distance_label"
      >Величина</label>
      <b-form-input
        id="stageLength"
        :key="'stage.stage_length_' + i"
        v-model="stage.stage_length"
        placeholder="Величина"
        vs-placeholder="Величина"
        class="distance-stage--input"
      />

      <template>
        <div>
          <div class="distance_label">
            Дополнительные поля - {{ stage.additional_fields.length }}
          </div>
          <template v-for="(additionalField, index) in stage.additional_fields">
            <additionalField
              :key="'additionalField' + index"
              :stage="stage"
              :field="additionalField"
              :field-index="index"
              :is-restricted="isRestricted"
              @update-field="updateField"
              @delete-field="deleteField"
            />
          </template>
          <div
            id="add-stage-additional-filed-tooltip"
            class="d-inline-block"
            tabindex="0"
          >
            <b-button
              type="submit"
              variant="primary"
              class="distance-stage--button"
              @click="addField(stage)"
            >
              Добавить дополнительное поле
            </b-button>
          </div>
          <b-tooltip
            v-if="isRestricted"
            target="add-stage-additional-filed-tooltip"
            triggers="hover"
          >
            В данной дистанции есть регистрации
          </b-tooltip>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import {
  BFormInput,
  BFormCheckbox,
  BButton,
  BFormCheckboxGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { v4 as uuidv4 } from 'uuid'
import crud_module from '../../../libs/crud_module'
import AdditionalField from './AdditionalField.vue'

const kind_of_sports = crud_module({
  entity_name: 'kind-of-sport',
})

export default {
  name: 'Stages',
  components: {
    BFormInput,
    BFormCheckbox,
    BButton,
    BFormCheckboxGroup,
    vSelect,
    AdditionalField,
  },
  props: ['stages', 'isRestricted'],
  data() {
    return {
      kindOfSports: [],
    }
  },
  created() {
    this.getKindOfSports()
  },
  methods: {
    async getKindOfSports() {
      const data = await kind_of_sports.fetchItems()
      this.kindOfSports = data.data && data.data.rows
    },
    addField(stage) {
      const uuid = uuidv4()
      stage.additional_fields.push({
        name: '',
        type: '',
        uuid,
      })
    },
    updateField(field, fieldIndex, stage) {
      stage.additional_fields[fieldIndex] = field
    },
    deleteField(fieldIndex, stage) {
      stage.additional_fields.splice(fieldIndex, 1)
    },
    deleteStage(stage) {
      this.$emit('deleteStage', stage)
    },
  },
}
</script>
<style lang="scss" scoped>
.vs__dropdown-menu {
  top: 0;
}

.distance-stage--input {
  margin-bottom: 0.5rem;
}

.distance_label {
  display: block;
  font-size: 0.75rem;
  margin-bottom: unset;
  cursor: pointer;
}

.distance_label__border {
  &:first-child {
    border-top: unset;
    margin-top: unset;
  }
  border-top: 1px solid white;
  margin-top: 1rem;
}

.distance-stage--button {
  margin-top: 0.5rem;
}
</style>
